import { Column } from "@/components";
import {
  WinterfellCastle,
  WinterfellNightKing,
  WinterfellWeirwood,
} from "@/components/staffer-pets/playyard/winterfell";
import { PlayyardSky } from "@/types";

const PINES = [
  { x: 68, size: 4 },
  { x: 72, size: 5 },
  { x: 76, size: 3.5 },
  { x: 80, size: 4.2 },
  { x: 94, size: 4.4 },
  { x: 98, size: 6 },
];

export const PlayyardLandLayer = ({ sky }: { sky: PlayyardSky }) => {
  /* Render */
  const render = () => (
    <Column className="pointer-events-none absolute inset-0">
      <svg
        className="absolute inset-x-0 top-[23%] h-[34%] w-full"
        viewBox="0 0 1000 220"
        preserveAspectRatio="none"
      >
        <path
          d="M0 170 100 49 156 110 252 12 345 119 446 42 518 116 626 4 740 121 815 53 906 143 970 78 1000 120V220H0Z"
          fill="var(--yard-farHill)"
        />
        <path
          d="m70 85 30-36 56 61-35-19-21-19-17 21ZM211 63l41-51 48 61-31-16-17-23-15 29ZM582 56l44-52 56 61-38-19-18-21-19 34ZM792 84l23-31 38 45-24-15-13-14-10 18Z"
          fill="var(--yard-nearHill)"
        />
        <path
          d="M0 202Q150 158 310 196T620 190T1000 181V220H0Z"
          fill="var(--yard-midHill)"
        />
      </svg>
      <WinterfellCastle nightAmount={sky.nightAmount} />
      <WinterfellNightKing nightAmount={sky.nightAmount} />
      {PINES.map(({ x, size }) => (
        <svg
          key={x}
          className="absolute top-[45%] -translate-x-1/2"
          style={{
            left: `${x}%`,
            width: `${size}cqw`,
            height: `${size * 1.6}cqw`,
          }}
          viewBox="0 0 40 64"
        >
          <path d="M18 44H22V64H18Z" fill="#536477" />
          <path
            d="M20 0 7 25H12L3 42H10L0 56H40L30 42H37L28 25H33Z"
            fill="color-mix(in srgb, var(--yard-farHill) 65%, #263f4d)"
          />
          <path
            d="M20 0 7 25 20 19 33 25ZM12 28 3 42 20 37 37 42 28 28 20 31Z"
            fill="var(--yard-groundTop)"
          />
        </svg>
      ))}
      <Column
        className="absolute inset-x-0 bottom-0 top-[55%]"
        style={{
          background:
            "linear-gradient(var(--yard-groundTop), var(--yard-groundBottom))",
        }}
      >
        <svg
          className="absolute inset-0 h-full w-full"
          viewBox="0 0 1000 300"
          preserveAspectRatio="none"
        >
          <path
            d="M330 0 120 300H860L540 0Z"
            fill="var(--yard-waterBottom)"
            opacity="0.12"
          />
          <path
            d="M0 34Q230 4 500 34T1000 24M0 190Q280 155 550 200T1000 179M0 284Q270 244 600 278T1000 260"
            stroke="var(--yard-groundTop)"
            strokeWidth="11"
            fill="none"
            opacity="0.55"
          />
          <path
            d="M393 18 368 49M360 63 334 95M323 110 293 145M280 161 247 201"
            stroke="var(--yard-waterBottom)"
            strokeWidth="5"
            strokeDasharray="3 14"
            strokeLinecap="round"
            fill="none"
            opacity="0.22"
          />
        </svg>
      </Column>
      <WinterfellWeirwood />
    </Column>
  );

  return render();
};
